import { render, staticRenderFns } from "./TextStamp.vue?vue&type=template&id=6028f8b0&"
import script from "./TextStamp.vue?vue&type=script&lang=js&"
export * from "./TextStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports